export interface PartyBeneficiary {
  id: string;
  name: string;
  accountNumber: string;
  bank: string;
  bankName: string;
  bankAddress: string;
  bankCountry?: string;
  instructionIdentification?: string;
  beneficiaryProvince: string;
  beneficiaryPostalCode: string;
  beneficiaryCountry: string;
  beneficiaryCity: string;
  beneficiaryStreetName: string;
  beneficiaryBuildingName: string;
  beneficiaryBuildingNumber: string;
  beneficiaryAddressLine: string;
}

export enum BeneficiaryBankParams {
  bank = 'bank',
  bankName = 'bankName',
  bankAddress = 'bankAddress',
  bankCountry = 'bankCountry',
  instructionIdentification = 'instructionIdentification'
}

export interface BeneficiaryConditions {
  additionalFields?: { name: string }[];
}

export interface PaymentBeneficiariesListFilters {
  query?: string;
}
